import smartMoneyApiService from '@/request/smartMoney/smartMoney.api.service';
import { IAddressHistory } from '@/request/smartMoney/smartMoney.response.interface';
import { useBoomWallet } from '@boomeme/wallet-sdk';
import { useEffect, useState } from 'react';
export type TradeType = 'buy' | 'sell' | 'all';

export const useActivityList = () => {
  const { walletAddress, chain } = useBoomWallet();
  const [loading, setLoading] = useState(false);
  const [activityList, setActivityList] = useState<IAddressHistory[]>([]);
  const [tradeType, setTradeType] = useState<TradeType>('all');

  const fetchHistoryList = async () => {
    try {
      if (!walletAddress) return;
      setLoading(true);
      const res: any = await smartMoneyApiService.getAddressHistory({
        chain: chain == 'solana' ? 'sol' : 'bsc',
        address: walletAddress,
        swapType: tradeType,
      });
      if (res.statusCode == 500) {
        setLoading(false);
        return;
      }
      setActivityList(res);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistoryList();
  }, [chain, walletAddress, tradeType]);

  return { loading, activityList, tradeType, setTradeType };
};
